var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19.25H6.5C6.09 19.25 5.75 18.91 5.75 18.5C5.75 18.09 6.09 17.75 6.5 17.75H16.5C19.36 17.75 20.75 16.36 20.75 13.5V6.5C20.75 3.64 19.36 2.25 16.5 2.25H6.5C3.64 2.25 2.25 3.64 2.25 6.5C2.25 6.91 1.91 7.25 1.5 7.25C1.09 7.25 0.75 6.91 0.75 6.5C0.75 2.85 2.85 0.75 6.5 0.75H16.5C20.15 0.75 22.25 2.85 22.25 6.5V13.5C22.25 17.15 20.15 19.25 16.5 19.25Z",
    fill: "#26B5ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4998 10.87C10.6598 10.87 9.80978 10.61 9.15978 10.08L6.02978 7.57997C5.70978 7.31997 5.64978 6.84997 5.90978 6.52997C6.16978 6.20997 6.63977 6.14997 6.95977 6.40997L10.0898 8.90997C10.8498 9.51997 12.1398 9.51997 12.8998 8.90997L16.0298 6.40997C16.3498 6.14997 16.8298 6.19997 17.0798 6.52997C17.3398 6.84997 17.2898 7.32997 16.9598 7.57997L13.8298 10.08C13.1898 10.61 12.3398 10.87 11.4998 10.87Z",
    fill: "#26B5ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.25H1.5C1.09 15.25 0.75 14.91 0.75 14.5C0.75 14.09 1.09 13.75 1.5 13.75H7.5C7.91 13.75 8.25 14.09 8.25 14.5C8.25 14.91 7.91 15.25 7.5 15.25Z",
    fill: "#26B5ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 11.25H1.5C1.09 11.25 0.75 10.91 0.75 10.5C0.75 10.09 1.09 9.75 1.5 9.75H4.5C4.91 9.75 5.25 10.09 5.25 10.5C5.25 10.91 4.91 11.25 4.5 11.25Z",
    fill: "#26B5ED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmail);
export default __webpack_public_path__ + "static/media/send-email.3f1e8c379cc8aee64176109e29f346f1.svg";
export { ForwardRef as ReactComponent };